<template>
  <div class="orderlist">
    <el-table
      ref="multipleTable"
      :data="orderData.list"
      style="width: 100%"
      >
      <el-table-column type="expand">
        <template slot-scope="props">
          <el-form label-position="left" inline class="demo-table-expand">
            <el-form-item :label="item.title" v-for="(item,index) in orderData.form" :key="index">
              <span>{{ props.row[item.key] }}</span>
            </el-form-item>
          </el-form>
        </template>
      </el-table-column>
      <el-table-column
        v-for="(item,i) in orderData.column"
        :key="'column'+i"
        align='center'
        :label="item.title"
        :width="item.width">
        <template slot-scope="scope">
          <img v-if="item.falg==0" v-lazy="scope.row[item.key]" />
          <span v-else-if="item.falg==1">{{scope.row[item.key]}}</span>
          <span :class="scope.row[item.key]*1?'span2':'span1'" v-else-if="item.falg==2">{{scope.row[item.key]*1?'已确认':'未确认'}}</span>
          <el-button v-else :class="scope.row[item.key]*1?'span2':'span3'" @click="confirmOrder(scope)" :disabled="scope.row[item.key]*1">{{scope.row[item.key]*1?'已确认':'确认'}}</el-button>
        </template>
      </el-table-column>
      
    </el-table>
  </div>
</template>

<script>
import { reqMyOrderStatus } from "../../../../api";
  export default {
    props:['falg','orderData'],
    data() {
      return {
      }
    },
    mounted(){
      // this.init()
    },

    methods: {
      async confirmOrder(scope){//确认已读
        const response = await reqMyOrderStatus(scope.row.id)
        if (response.code*1==3) {
          this.success(this,'确认成功')
          this.$emit('initReceived')
        }else{
          this.err(this,'请求失败，稍后重试...')
        }
      }
    }
  }
</script>
<style scoped>

</style>

<style >
  .demo-table-expand {
    font-size: 0;
  }
  .demo-table-expand label {
    width: 80px;
    color: #99a9bf;
  }
  .el-form--inline .el-form-item__content{
    width: calc(100% - 80px);
    line-height: 24px;
    padding-bottom: 16px;
  }
  .el-form--label-left .el-form-item__label{
    text-align: end;
    line-height: 24px;
  }
  .demo-table-expand .el-form-item {
    margin-right: 0;
    margin-bottom: 0;
    width: 50%;
  }
  .el-table__expanded-cell,
  .el-table__expanded-cell:hover{
    background-color: #eeeeee26 !important;
  }
  .el-table--enable-row-transition .el-table__body td{
    min-height: 100px;
    max-height: 100px;
    height: 100px;
  }
  .orderlist .span1{
    background-color: #ecfafe;
    color: #008baf;
    padding: 10px 26px;
    display: inline-block;
    line-height: 1;
  }
  .orderlist .span2,.orderlist .span2:hover{
    background-color: #f2f2f2;
    color: #767676;
    border: none;
    padding: 10px 26px;
    display: inline-block;
    line-height: 1;
  }
  .orderlist .span3{
    background-color: #ecfafe;
    color: #008baf;
    border: #0e8faf;
  }
  .orderlist .span3:focus,.span3:hover{
    background-color: #ecfafe;
    color: #008baf;
    border: #0e8faf;
  }
  .el-icon-arrow-right:before{
    font-size: 16px;
    font-weight: 600;
  }
</style>